import { ViewJobConstants } from 'config';
import JobDescriptionPage from 'pages/common/IPriseJobs/JobDescriptionPage';
import { JobView } from 'pages/common/job/JobView';
import { Resumes } from 'pages/common/Resumes/Resumes';
import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

const ipriseRoute = 'iprise-job';
export const ViewJob: React.FC<any> = () => {
  const params = useParams();
  const location = useLocation();
  const { jobtab } = params;
  if (location.pathname.includes(ipriseRoute)) {
    return <JobDescriptionPage />;
  } else if (jobtab === ViewJobConstants.Resumes) {
    return <Resumes />;
  } else {
    return <JobView />;
    //
  }
};
